import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, NonNullableFormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';

import { post1 } from 'src/utils/api';
import { APP_API_URL, APP_HD_URL1 } from 'src/utils/urls';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { SessionActions } from 'src/app/store/session.actions';

@Component({
  selector: 'change-pwd-modal',
  templateUrl: './change-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChangePasswordModalComponent {
  @ViewChild('myInput') myInput!: ElementRef;

  constructor(
    private fb: NonNullableFormBuilder,
    private message: NzMessageService,
    private router: Router,
    private store: Store
  ) {
    this.validateForm = this.fb.group({
      currentPassword: ['', [Validators.required, this.passwordValidator]],
      newPassword: ['', [Validators.required, this.passwordValidator]],
      confirmPassword: ['', [Validators.required, this.confirmationValidator]]
    });
  }
  @Input() isVisible = false;
  @Output() closeModalEvent = new EventEmitter<boolean>();

  showCurrPwd = false;
  showPwd = false;
  showConfPwd = false;
  validateForm: FormGroup<{
    currentPassword: FormControl<string>;
    newPassword: FormControl<string>;

    confirmPassword: FormControl<string>;
  }>;

  ngOnChanges() {}
  handleOk(): void {
    this.closeModalEvent.emit(false);
  }

  handleCancel(): void {
    this.closeModalEvent.emit(false);
  }

  passwordValidator(control: any): { [key: string]: boolean } | null {
    const value = control.value;
    if (!value) {
      return null;
    }

    // Regex for strong password
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
    const isValidLength = value.length >= 8;

    if (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecialChar || !isValidLength) {
      return { passwordStrength: true }; // Return error if password does not meet criteria
    }

    return null;
  }

  confirmationValidator: ValidatorFn = (control: AbstractControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.validateForm.controls.newPassword.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  updateConfirmValidator1 = async () => {
    Promise.resolve().then(() => this.validateForm.controls.confirmPassword.updateValueAndValidity());
  };

  updateConfirmValidator2 = async () => {
    Promise.resolve().then(() => this.validateForm.controls.currentPassword.updateValueAndValidity());
  };
  submitForm = async () => {
    if (this.validateForm.valid) {
      let res: any = await post1(APP_HD_URL1 + 'api/Authentication/change-password', {
        currentPassword: this.validateForm.value.currentPassword,
        newPassword: this.validateForm.value.newPassword,
        confirmPassword: this.validateForm.value.confirmPassword
      });
      if (res?.status === 200) {
        this.message.create('success', 'Password updated successfully!');
        this.closeModalEvent.emit(true);
        const tenantId = localStorage.getItem('tenantId');
        const tenantName = localStorage.getItem('tenantName');
        const tenant_config = localStorage.getItem('tenant_config');
        // Unlike the other sign-outs this doesn't reload the page, so the store has to let go of
        // the session itself — sessionStorage.clear() alone no longer covers the screens' filters.
        this.store.dispatch(SessionActions.signedOut());
        localStorage.clear();
        sessionStorage.clear();
        if (tenantId) localStorage.setItem('tenantId', tenantId);
        if (tenantName) localStorage.setItem('tenantName', tenantName);
        if (tenant_config) localStorage.setItem('tenant_config', tenant_config);
        this.router.navigate(['/guest/login'], tenantId ? { queryParams: { tenantId } } : {});
      } else if (res?.status === 400) {
        this.message.create(
          'error',
          res?.response?.data?.statusMessage ? res?.response?.data?.statusMessage : 'Error while updating password!'
        );
      } else {
        this.message.create('error', 'Error while updating password!');
      }
    } else {
      Object.values(this.validateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  };

  onShowPwd1 = (e) => {
    this.showPwd = !e;
  };

  onShowCurrPwd = (e) => {
    this.showCurrPwd = !e;
  };

  onShowConfPwd = (e) => {
    this.showConfPwd = !e;
  };
}
